import { Footer } from "@/components/common/Footer";
import Navbar from "@/components/common/Navbar";
import { SizedBox } from "@/components/core/SizedBox";
import { TopArea } from "./TopArea";
import { Experiences } from "./Experiences";
import { Education } from "./Education";
import "@/pages/Home/style.css"
import { Skills } from "./Skills";

const Home = () => {
    return (
        <div
            style={{
                backgroundColor: 'var(--color-bg)',
            }}
        >
            <Navbar />
            <div className="view"
            >
                <SizedBox height={10} />
                <TopArea />
                <SizedBox height={50} />
                <Skills />
                <SizedBox height={50} />
                <Education />
                <SizedBox height={50} />
                <Experiences />
                <SizedBox height={50} />
            </div>
            <Footer />

        </div>
    );
}


export default Home;